<div *ngIf="isAdminObservable | async" class="card">
	<div class="card-body">

		<al-tabs [tabInfo]="tabInfos" [selectedTab$]="selectedTabId$" [onTabClick]="onTabClick">
		</al-tabs>

		<div class="tabs-container" style="padding: 20px 10px 10px 10px;">
			<router-outlet></router-outlet>
		</div>

	</div>
</div>
